import { Alert, Button } from "react-bootstrap"
import BadgeEstados from "../../BadgeEstado"
import { getActaDetalleHandler } from "../../../handlers/actaDetalle.handler"
import { useLocation } from "react-router-dom"
import { useGeneralAppStore } from "../../../store/generalAppStore"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { FileXIcon } from "../../Icons";
import DoDisturbAltIcon from '@mui/icons-material/DoDisturbAlt';

const Anulada = ({ aPrev, aPos, amp, amt, acta }) => {

    const { handlerModal } = useGeneralAppStore();
    const path = useLocation().pathname



    return (
        <div>
            {
                <Alert variant="danger" className="d-flex flex-column gap-2 align-items-center">
                    <div className="bg-white d-flex flex-column align-items-center gap-1 p-2 py-4 border rounded shadow-lg w-100">
                        <b className="text-center">Acta anulada</b>
                        <div className="d-flex flex-column alig-items-center gap-1">
                            <div className="d-flex align-items-center gap-2">
                                <p className="m-0">Motivo: </p>
                                <p className="m-0 fw-bold">{acta?.motivo?.estado?.nombre}</p>
                            </div>
                            {
                                acta?.motivo?.motivo &&
                                <p className="m-0 fw-medium">Detalle: <span className="fw-bold">{acta?.motivo?.motivo}</span></p>
                            }
                        </div>
                        {
                            path.includes('/actas-anuladas') &&
                            <div>

                                < div className="d-flex flex-column gap-2 align-items-center">
                                    <div className=" d-flex flex-column align-items-center gap-3 p-4  rounded  w-100">
                                        <span className="text-center">Verifique y confirme la anulacion del acta</span>
                                        <div className="d-flex gap-3 flex-wrap justify-content-center">
                                            {!(aPrev?.some(acta => [3, 7].includes(acta?.estado_id))) && <Button variant="success" size="sm" className="d-flex gap-1 align-items-center" onClick={() => { handlerModal({ modal: true, modalName: "aprobada_imprimir" }) }}><CheckCircleIcon /> Aprobar</Button>}
                                            <Button variant="danger" size="sm" className="d-flex gap-1 align-items-center" onClick={() => { handlerModal({ modal: true, modalName: "incompleta_acta_detalle" }) }}><FileXIcon color="#fff" /> Incompleta</Button>
                                            <Button variant="danger" size="sm" className="d-flex gap-1 align-items-center" onClick={() => { handlerModal({ modal: true, modalName: "modal_confirm" }) }}><DoDisturbAltIcon />Confirmar anulación</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            aPrev?.some(acta => acta?.estado_id == 3)
                            &&
                            <div className="border w-100 d-flex flex-column align-items-center gap-2 justify-content-center py-2">

                                <BadgeEstados estado_id={3} />
                                <div>
                                    {
                                        aPrev?.filter(acta => acta?.estado_id == 3).map((a, index) => {
                                            return (
                                                <div key={index}
                                                    className={`bg-secondary px-2 rounded  text-white fw-bold `}
                                                    style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                    onClick={() => {
                                                        if (index == 0) {
                                                            getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                        }
                                                    }}
                                                >
                                                    <p className="m-0">Acta - {a?.numero_acta}</p>
                                                </div>
                                            )
                                        })
                                    }

                                </div>
                            </div>
                        }
                        {
                            aPrev?.some(acta => acta?.estado_id == 7)
                            &&
                            <div className="border w-100 d-flex flex-column align-items-center gap-2 justify-content-center py-2">

                                <BadgeEstados estado_id={7} />
                                <div>
                                    {
                                        aPrev?.filter(acta => acta?.estado_id == 7).map((a, index) => {
                                            return (
                                                <div key={index}
                                                    className={`bg-danger px-2 rounded  text-white fw-bold `}
                                                    style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                    onClick={() => {
                                                        if (index == 0) {
                                                            getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                        }
                                                    }}
                                                >
                                                    <p className="m-0">Acta - {a?.numero_acta}</p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </Alert>
            }
        </div >
    )
}

export default Anulada;